import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {VueJsonp} from 'vue-jsonp';
import VueAxios from 'vue-axios';
import axios, {AxiosStatic} from 'axios'

Vue.config.productionTip = false
import "@/assets/css/global.css"

declare const window: any;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', to.fullPath])
    }
  }
  next()
})

Vue.use(VueJsonp)
Vue.use(VueAxios, axios)
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
Vue.prototype.$axios = axios;
declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosStatic;
  }
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
